Ext.define('SA.BarChartYAxis', {
    singleton: true,

    createBuilder({cfg, attribute, scale}) {
        var tickFormatter = SA.data.AttributesCache.getTickFormatter(scale.ticks(cfg.yAxisTickCount), attribute);

        return d3.axisLeft(scale).ticks(cfg.yAxisTickCount).tickFormat(tickFormatter).tickSize(0);
    },

    createTitleEl({cfg, attribute, yAxisHeight}) {
        return SA.BalancedChartText.get({
            color: cfg.axisTitleFontColor,
            fontFamily: cfg.fontFamily,
            fontSize: cfg.axisTitleFontSize,
            letterSpacing: '0.2px',
            lineHeight: cfg.axisTitleLineHeight,
            maxWidth: yAxisHeight,
            text: SA.data.AttributesCache.getLabel(attribute),
            textAnchor: 'middle'
        });
    },

    render(axis, cfg, scale, attribute, yAxisHeight) {
        var builder = this.createBuilder({cfg, attribute, scale}),
            titleEl = this.createTitleEl({cfg, attribute, yAxisHeight}),
            wrapEl;

        axis.append('g')
            .attr('class', 'wrap')
            .call(builder)
            .call(axis => this.styleLabels({cfg, axis}))
            .call(axis => axis.selectAll('.domain').attr('stroke', cfg.outerGridLineColor));

        wrapEl = axis.select('.wrap').node();
        wrapEl.append(titleEl);

        this.transformTitle({cfg, yAxisHeight, wrapEl, titleEl});
    },

    styleLabels({cfg, axis}) {
        axis.selectAll('text')
            .attr('fill', cfg.yAxisFontColor)
            .attr('dx', 0 - cfg.yAxisLabelOffset)
            .style('font-family', cfg.fontFamily)
            .style('font-size', cfg.yAxisFontSize)
            .style('font-variant', cfg.fontVariant)
            .style('letter-spacing', '0.2px');
    },

    transformTitle({cfg, yAxisHeight, wrapEl, titleEl}) {
        var labelWidths = [...wrapEl.querySelectorAll('.tick')].map(tick => tick.getBBox().width),
            maxLabelWidth = Math.max(...labelWidths),
            x = 0 - maxLabelWidth - cfg.axisTitleMargin - titleEl.getBBox().height,
            y = yAxisHeight / 2;

        SA.Svg.setAttr(titleEl, 'transform', `translate(${x} ${y}) rotate(-90)`);
    }
});